export interface CatalogOutcomeDefinition {
  title: string;
  examples: string;
  supportingSkus: readonly string[];
}

export type CatalogOutcomeDefinitionMap = Readonly<
  Record<string, readonly CatalogOutcomeDefinition[]>
>;

export const defineOutcome = (
  title: string,
  examples: string,
  ...supportingSkus: string[]
): CatalogOutcomeDefinition => ({ title, examples, supportingSkus });
